<template>
  <div  class="member-price" v-if="isShowMemberPrice && !!memberPrice" :style="mStyle">
    <span class="symbol">￥</span>
        <!-- 'left': isBig ? '-.1rem' : '-.12rem', -->
    <span class="member-price-int"
      :style="{
        'font-size': isBig ? '.36rem' : '.28rem',
        'top': isBig ? '.02rem' : '0',
      }">
      {{memberPrice | formatPrice | formatPriceInt}}
    </span>
    <span class="member-price-float" >
      {{memberPrice | formatPrice | formatPriceFloat}}{{hasMinPrice ? '起' : ''}}
    </span>
    <img src="//cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/plus.png" />
  </div>
</template>
<script>
export default {
  props: ['memberPrice', 'mStyle', 'isBig', 'hasMinPrice'],
  data() {
    return {
      isShowMemberPrice: this.$util.isShowMemberPrice(),
    }
  }
}
</script>
<style lang="scss" scoped>
.member-price {
  display: flex;
  flex-direction: row;
  font-size: 0.24rem;
  color: #333;
  line-height: 0.28rem;
  font-weight: bold;
  align-items: baseline;
  font-family: DINAlternate, DINAlternate-Bold;
  margin-left: .08rem;
  .symbol{
    position: relative;
    left: .02rem;
    top: .02rem;
    font-size: .24rem;
    font-weight: bold;
    display: inline-block;
    transform: scale(.83);
    transform-origin: left;
    margin-right: -.04rem;
  }
  .member-price-int{
    position: relative;
    font-size: 0.28rem;
    font-weight: bold;
    display: inline-block;
    top: .02rem;
  }
  .member-price-float{
    position: relative;
    /* left: -.18rem; */
    top: .02rem;
    font-size: 0.24rem;
    font-weight: bold;
    display: inline-block;
    white-space: nowrap;
    transform: scale(.83);
    transform-origin: left;
    margin-right: -.04rem;
  }
  img {
    position: relative;
    top: .02rem;
    /* left: -.23rem; */
    height: .24rem;
    width: .68rem;
    display: inline-block;
  }
}
</style>
